import styled from "styled-components";
import colors from "styles/colors";

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  width: 100%;
  gap: 184px;
  height: 88px;
  box-sizing: border-box;
  border-top: 1px solid #E6E9EF;
  border-radius: 0px 0px 16px 16px;
`;

export const LeftButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 89px;
  height: 40px;
  margin-left: auto;
  box-sizing: border-box;
  border: 1px solid ${colors.blue70};
  border-radius: 4px;
`;

export const RightButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 89px;
  height: 40px;
  margin-left: auto;
  box-sizing: border-box;
`;

export const ButtonContainer = styled.div`
  display: flex;
  align-items: flex-start;
  padding: 0px;
  gap: 24px;
  width: 198px;
  height: 40px;
  margin-left: auto;
  box-sizing: border-box;
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.4px;
`;
